import DropDown from './drop-down';

class DropDownInput extends DropDown {
    constructor() {
        super();

        this.checkValue = this.checkValue.bind(this);
        this.dropDownInput = null;
        this.dropdownChange();
    }

    dropdownChange() {
        const button = this.querySelector('.recomended__filter');
        button.addEventListener('click', () => {
            const value = button.getAttribute('aria-expanded') === 'true';
            button.setAttribute('aria-expanded', String(!value));
            this.trapFocus(document.querySelector('.dropdown-menu__sortedBt'))
        })
    }

    trapFocus(dialog) {
        const focusableElements = dialog.querySelectorAll('a, button, select, textarea, [tabindex]:not([tabindex="-1"])');

        const firstFocusableElement = focusableElements[0];
        const lastFocusableElement = focusableElements[focusableElements.length - 1];

        dialog.addEventListener('keydown', (e) => {
            if (e.key === 'Tab') {

                if (e.shiftKey) { // Shift + Tab
                    if (document.activeElement === firstFocusableElement) {
                        e.preventDefault();
                        lastFocusableElement.focus(); // Move focus to last element if Shift + Tab on first element
                    }
                } else {
                    // eslint-disable-next-line
                    if (document.activeElement === lastFocusableElement) {
                        e.preventDefault();
                        firstFocusableElement.focus(); // Move focus to first element if Tab on last element
                    }
                }
                if (document.activeElement === lastFocusableElement) {
                    e.preventDefault();
                    firstFocusableElement.focus(); // Move focus to first element if Tab on last element
                }
            }
        });
    }

    checkValue() {
        this.dropDownInput = this.querySelectorAll('.js-drop-down-input');
        this.sortTitle = this.querySelector('.sort_method');

        if (!this.dropDownInput.length) return;

        this.dropDownInput.forEach(checkbox => {
            checkbox.addEventListener('change', () => {

                this.dropDownInput.forEach(input => {
                    if (input !== checkbox) {
                        input.removeAttribute('checked');
                    }
                });

                if (checkbox.checked) {
                    if (this.sortTitle) {
                        this.sortTitle.textContent = checkbox.getAttribute("data-name") || checkbox.value;
                    }

                    checkbox.setAttribute('checked', 'checked');
                } else {
                    checkbox.removeAttribute('checked');
                }
            });
        });
    }

    connectedCallback() {
        super.connectedCallback();
        this.checkValue();
    }
}

const init = () => {
    if (!customElements.get("custom-dropdown-input")) {
        customElements.define('custom-dropdown-input', DropDownInput);
    }
};

init();
